import { defineComponent as k, computed as o, useAttrs as r, inject as c, ref as C, watch as g, onMounted as B, createElementBlock as d, openBlock as u, normalizeClass as f, createVNode as N, unref as T, mergeProps as A, withCtx as E, createElementVNode as m, createCommentVNode as I, toDisplayString as V, renderSlot as K } from "vue";
import "@ds/components/Badge";
import { RevButtonBase as R } from "@ds/components/ButtonBase";
import { variantKey as S, setActiveTabKey as $ } from "@ds/components/Tabs";
import { useTrackedListeners as j } from "../../composables/useTrackedListeners.js";
import { tw as e } from "../../utils/tailwind.js";
const z = {
  key: 0,
  class: "ml-8 align-middle"
}, H = /* @__PURE__ */ k({
  name: "RevTabItem",
  inheritAttrs: !1,
  __name: "TabItem",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    label: {}
  },
  emits: ["click"],
  setup(l, { emit: v }) {
    const t = l, b = v, p = o(() => {
      const { listeners: a } = j(t);
      return {
        ...r(),
        ...a,
        class: void 0
      };
    }), s = c(S), n = c($), i = C(null), x = o(() => [
      e`relative flex h-56 list-none items-center`,
      s === "fixed" && e`flex-1`,
      s === "flexible" && e`whitespace-nowrap`
    ]), h = o(() => [
      e`focus-visible-outline-inset-hi flex h-full items-center border-none bg-transparent p-0 text-center no-underline motion-safe:transition motion-safe:duration-200`,
      !t.active && !t.disabled && e`text-action-default-low cursor-pointer hover:bg-static-default-min-hover hover:text-action-default-low-hover`,
      t.active && !t.disabled && e`text-action-default-low-pressed pointer-events-none cursor-default`,
      t.active && e`body-1-bold`,
      !t.active && e`body-1`,
      t.disabled && e`text-action-default-low-disabled cursor-not-allowed`,
      s === "fixed" && e`flex-1 px-12`,
      s === "flexible" && e`overflow-hidden text-ellipsis`
    ]), w = o(() => [
      r().class,
      s === "fixed" && e`line-clamp-2 grow`
    ]), y = (a) => {
      t.disabled || b("click", a);
    };
    return g(
      () => t.active,
      async (a) => {
        a && n && i.value && n(i.value);
      }
    ), B(async () => {
      t.active && n && i.value && n(i.value);
    }), (a, D) => (u(), d("li", {
      ref_key: "tab",
      ref: i,
      class: f(x.value)
    }, [
      N(T(R), A(p.value, {
        "aria-selected": l.active,
        class: h.value,
        disabled: l.disabled,
        title: l.label,
        onClick: y
      }), {
        default: E(() => [
          m("span", {
            class: f(w.value)
          }, [
            m("span", null, V(l.label), 1),
            a.$slots.default ? (u(), d("span", z, [
              K(a.$slots, "default")
            ])) : I("", !0)
          ], 2)
        ]),
        _: 3
      }, 16, ["aria-selected", "class", "disabled", "title"])
    ], 2));
  }
});
export {
  H as default
};
